import {ErrorFromBE} from 'types/ErrorFromBE';
import showError from './showError';

const showRequestError = (title: string, data: ErrorFromBE) => {
    data.forEach((err) => { if (!err.field) { showError(title, err.message); } });
};

export default showRequestError;
